import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { dataSourceAdapterBaseConfigSchema } from "./shared-config";
import { fwfColumnMappingSchema, fwfOptionsSchema } from "../fwf-shared";

export const fwfDataSourceAdapterStep = defineStepConfig({
  type: "fwf_datasource_adapter",
  name: "Fwf DataSource Adapter",
  description:
    "Transform a fixed-width file in Azure Blob Storage into FWF chunks.",
  category: "DataSource Adapter",

  inputSchema: z.object({
    blobStorageUri: z
      .string()
      .describe("Blob Storage URI of the source fixed-width file"),
    storageProfile: z
      .string()
      .describe(
        "Storage profile key that identifies the credentials to use to access the Blob Storage URI",
      ),
  }),

  outputSchema: z.object({
    blobStorageUris: z
      .array(z.string())
      .describe(
        "Blob Storage URIs of the fixed-width file chunks (.txt). Each URI can be fanned out to a downstream step that accepts a single URI as input.",
      ),
    storageProfile: z
      .string()
      .describe(
        "Storage profile key that identifies the credentials to use to access the Blob Storage URIs",
      ),
    dataSourceLinks: z
      .array(z.string().uuid())
      .describe("DataIngestLink UUIDs resolved from the configured strategy"),
    fwfOptions: fwfOptionsSchema.describe(
      "Fixed-width file parsing options this step was configured with, propagated for use by downstream steps.",
    ),
  }),

  configSchema: dataSourceAdapterBaseConfigSchema.extend({
    fwfColumnMappings: z
      .array(fwfColumnMappingSchema)
      .optional()
      .describe(
        "Ordered list of column definitions. Each entry maps a schema field to its " +
          "0-based character offset and character length in the fixed-width record.",
      ),

    encoding: z.string().optional().describe("File encoding (default: utf-8)"),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "10 minutes",
    retry: {
      maximumAttempts: 3,
      backoffCoefficient: 2,
      initialInterval: "10 seconds",
    },
  },
});
